<template>
  <div class="container" @click="$emit('click')">
    <div class="Text-Title" :style="backgroundStyle">
      {{ title }}
    </div>
  </div>
</template>

<script>
import unstarted from '@/assets/status/noncommenc@3x.png'
import pending from '@/assets/status/encours@3x.png'
import finished from '@/assets/status/finished@3x.png'

export default {
  name: 'VvDesktopTile',
  props: {
    title: {
      type: String,
      required: true
    },
    secondary: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    status: {
      type: String,
      required: false,
      validator(val) {
        return !val || ['unstarted', 'running', 'finished'].includes(val)
      }
    }
  },
  computed: {
    icon() {
      if (this.status === 'finished') return finished

      if (this.status === 'running') return pending

      return unstarted
    },
    backgroundStyle() {
      return this.image ? `background: center / cover no-repeat url(${this.image})` : null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.container {
  background-color: inherit;
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: flex-end;
  overflow: hidden;
  width: 250px;
  height: 250px;
  flex-direction: column;
  border-radius: 8px;
  padding-bottom: 1px;
  // background-color: rgba(0, 0, 0, 0.9);
  box-shadow: inset 0px 0 300px 5px rgba(0, 0, 0, 0.7), 0 3px 10px rgba(216, 216, 216, 0.5);
  transition: all 200ms linear;

  &:hover {
    box-shadow: inset 0px 0 300px 5px rgba(0, 0, 0, 0.7), 3px 6px 13px rgba(216, 216, 216, 0.8);
  }

  .Header-Button-Wrapper {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .Text-Title {
    align-self: center;
    text-align: center;
    vertical-align: middle;
    margin: auto;
    font-size: 20px;
    font-weight: bold;
    color: #fff;
    width: 100%;
    height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: inset 0px 0 300px 5px rgba(0, 0, 0, 0.7), 0 3px 10px rgba(216, 216, 216, 0.5);
    transition: all 200ms linear;
    border-radius: 8px 8px 0px 0px;

    // padding-left: 10px;
    // padding-right: 10px;
  }

  .Toast {
    // position: absolute;
    width: 100%;
    background-color: #fff;
    display: flex;
    color: $font-color;
    align-items: center;
    border-radius: 0px 0px 8px 8px;
    height: 50px;
    box-shadow: 0px 10px 3px 10px rgba(0,0,0,0.01);
    transition: all 200ms linear;

    .Text-Container {
      width: 100%;
      text-align: left;
      box-sizing: border-box;

      .Time {
        align-self: flex-start;
        margin-left: 10px;
        font-size: 18px;
        font-weight: normal;
      }
    }

    .Icon-Container {
      display: inline-block;
      text-align: right;
      margin-right: 5px;
      margin-top: 5px;
      width: 10%;

      img {
        height: 25px;
        width: 25px;
      }
    }
  }
}
</style>
